import { render, staticRenderFns } from "./ConversationModal.vue?vue&type=template&id=50e2f3e1&scoped=true"
import script from "./ConversationModal.vue?vue&type=script&lang=js"
export * from "./ConversationModal.vue?vue&type=script&lang=js"
import style0 from "./ConversationModal.vue?vue&type=style&index=0&id=50e2f3e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2f3e1",
  null
  
)

export default component.exports